import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { fuseAnimations } from '@library/animations';
import { FuseAlertComponent, FuseAlertType } from '@library/components/alert';
import { AlertManagerService } from './services/alert-manager.service';
import { AppVersionService } from './services/app-version.service';
import { PwaService } from './services/pwa.service';
import { ThemeSchemeService } from './services/theme-scheme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: fuseAnimations,
  imports: [RouterOutlet, FuseAlertComponent],
  standalone: true,
})
export class AppComponent implements OnInit {
  public alerts: WritableSignal<{ id: string; type: FuseAlertType; message: string }[]> = signal([]);

  constructor(
    private readonly alertMService: AlertManagerService,
    public pwaService: PwaService,
    private readonly appVersionService: AppVersionService,
    /**
     * Se inyecta aquí solo para que se construya: al hacerlo aplica el tema guardado.
     * Si esperara al botón de la cabecera, el tema se corregiría **después** de pintar
     * —incluida la pantalla de login, que no tiene cabecera— y se vería el parpadeo.
     */
    private readonly themeScheme: ThemeSchemeService
  ) {}

  ngOnInit(): void {
    this.alertMService.alerts.subscribe((alerts) => {
      this.alerts.set(alerts);
    });
    this.appVersionService.checkVersion();
  }
}
